<template lang="pug">
div.nav_menu_wrapper
  nav(
    class="nav-menu"
    :class="{ small: searchIsFocused }"
  )
    slot(name="menu")
      main-nav(
        :items="localItems"
        :max-level="menuMaxLevel"
        :small="searchIsFocused"
      )
  div(
    class="nav-search"
    :class="{ wide: searchIsFocused }"
  )
    slot(name="search")
      main-search(
        :target="searchTarget"
        :field-name="searchName"
        :field-value="searchValue"
        @submit="onSubmit"
        v-if="searchIsFocused || !hasMenuItems"
        @blur="onFocusSearch(false)"
        @focus="onFocusSearch(true)"
        :has-focus="hasMenuItems"
      )
      AppSvgIconNew.search_glass.ui_icon_stroke_transparent.nav_svg_icon(
        v-else,
        @click='searchIsFocused = !searchIsFocused',
        as-is-button,
        :template='$ui.IconSvgComponents.searchGlass',
        size='medium'
      )
</template>

<script>
import MainSearch from '@/components/parts/form/Search.vue';
import MainNav from '@/components/parts/nav/Compact.vue';
import checkMobile from '@/mixins/checkMobile';
import AppSvgIconNew from "@/uikit/components/AppSvgIconNew";

export default {
  mixins: [checkMobile],

  components: {
    MainSearch,
    MainNav,
    AppSvgIconNew,
  },

  props: {
    menuItems: {
      type: Array,
      default: () => [],
    },

    searchTarget: {
      type: [String, Object],
      default: '',
    },

    searchName: {
      type: String,
      default: '',
    },

    searchValue: {
      type: String,
      default: '',
    },

    collapsedTitle: {
      type: String,
      default: 'Каталог',
    },

    menuMaxLevel: {
      type: Number,
      default: 2,
    },
  },

  data: () => ({
    extClick: false,
    searchIsFocused: false,
  }),

  computed: {
    hasMenuItems() {
      return this.$store.state.sections.length > 0;
    },
    localItems() {
      return this.searchIsFocused
        ? [
            {
              text: this.collapsedTitle,
              callback: ($event) => {
                $event.preventDefault();
                this.searchIsFocused = false;
              },
            },
          ]
        : this.menuItems;
    },
  },

  methods: {
    onSubmit(data) {
      this.$emit('submitSearch', data);
    },

    onFocusSearch(value) {
      this.searchIsFocused = value;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/stylus/helpers/mediaqueriesStep'

$smallWidth = 10.9%
$defaultWidth = 75.35%
$paddingRight = 9px

.nav_menu_wrapper {
  display flex
}


.nav-menu
.nav-search
  transition width 0s ease-in-out 0s
  float left
  align-self: center
.nav_svg_icon {
  margin-top: 5px;
  color: #fff;
}
.nav-menu
  box-sizing border-box
  position relative
  padding-right 6px
  +phone-only()
    display inline-block
    width 100%
    padding 0 6px 0 0
  +tablet()
    display inline-block
    width 100%
    padding 0 6px 0 0
  +desktop()
    flex auto
    box-sizing border-box
    padding-right 5px
  &.small
    flex auto
    width: auto;
    padding-right $paddingRight

/* ------------------------------ */
.nav-search
    position relative
    margin-bottom 10px
    +phone-only()
        display inline-block
        width 100%
        padding 0
        margin-top 10px
    +tablet()
        display inline-block
        padding 0
        margin-top 10px
    +desktop()
        margin 0
    &.wide
        width 100% - $smallWidth
</style>



// WEBPACK FOOTER //
// Nav.vue?4cd15a8c